import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import './style.scss';

// 转股记录
const TransferHistory = () => {
    return (
        <Card form className="transfer-history-root">
            <Outlet />
        </Card>
    );
};

export default TransferHistory;
